const { objectOperator } = require('../agent/utils/spread');
const commons = require('./commons');

const metricSupport = [
  'css',
  'img',
  'link',
  'script',
  'other',
];


module.exports = objectOperator([commons, { metricSupport }]);
